export default __webpack_public_path__ + "media/images/placeholders/mud-run-55d58455e9d76b4a1f2118434aadd803.jpg";